module.exports = __webpack_public_path__ + "1ef48f7c.svg";